module.exports = __webpack_public_path__ + "img/voopoo.e84b7cb4.png";